import { client } from "@/api/client";
import interceptors from "@/api/interceptors";
import qs from "qs";

client.interceptors.request.use(interceptors.auth, interceptors.onError);

function getProfileMitra(params) {
	return client.get("personal/profile", {
		params: params,
	});
}

function getAccountMitra(params) {
	return client.get("member/account", {
		params: params,
	});
}

function editProfileMitra(params) {
	return client.post("personal/update", params, {
		header: {
			"Content-Type": "multipart/form-data"
		}
	});
}

function editPhotoMitra(params) {
	return client.post("personal/update/photo", params, {
		header: {
			"Content-Type": "multipart/form-data"
		}
	});
}

function editPasswordMitra(params) {
	return client.post("personal/update/password", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getBankMitra(params) {
	return client.get("binary/personal/my-bank", {
		params: params,
	});
}

function getBankPramitra(params) {
	return client.get("membership/personal/my-bank", {
		params: params,
	});
}

function getMitraData(params) {
	return client.get("general/get-member-by-id", {
		params: params,
	});
}

function editBankMitra(params) {
	return client.post("binary/personal/edit-my-bank", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function editBankPramitra(params) {
	return client.post("membership/personal/edit-my-bank", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

function getUpgradeStatus(params) {
	return client.get("check/upgrade", {
		params: params,
	});
}

function upgradeKhasanah(params) {
	console.log(qs.stringify(params))
	return client.post("upgrade", qs.stringify(params), {
		header: {
			"Content-Type": "application/x-www-form-urlencoded"
		}
	});
}

export default {
	getProfileMitra,
	getAccountMitra,
	editProfileMitra,
	editPhotoMitra,
	editPasswordMitra,
	getBankMitra,
	getBankPramitra,
	editBankMitra,
	editBankPramitra,
	getMitraData,

	getUpgradeStatus,
	upgradeKhasanah
};